/* eslint-disable @animech/axiom/no-references-in-top-level-values */
import { MaterialOptions, TableType } from "src/definitions/type-definitions";

export const tableOptions: Record<TableType, MaterialOptions> = {
	"Table-B31-84": {
		wood: [
			"WoodTeakUntreated",
			"WoodOakOiled",
			"LacquerWhite",
			"PaintWoodGreen",
			"PaintWoodRed",
		],
		metal: ["MetalGalvanizedSteel", "PaintMetalBlack"],
	},
	"Table-B31-170": {
		wood: [
			"WoodTeakUntreated",
			"WoodOakOiled",
			"LacquerWhite",
			"PaintWoodGreen",
			"PaintWoodRed",
		],
		metal: ["MetalGalvanizedSteel", "PaintMetalBlack"],
	},
	"Table-B31-230": {
		wood: [
			"WoodTeakUntreated",
			"WoodOakOiled",
			"LacquerWhite",
			"PaintWoodGreen",
			"PaintWoodRed",
		],
		metal: ["MetalGalvanizedSteel", "PaintMetalBlack"],
	},
	"Table-6B-60": {
		wood: [
			"WoodTeakUntreated",
			"WoodOakOiled",
			"WoodPineOiled",
			"LacquerWhite",
			"PaintWoodGreen",
			"PaintWoodRed",
		],
		metal: ["MetalGalvanizedSteel", "PaintMetalBlack", "PaintMetalGreen"],
		excludedCombos: [
			{ wood: "WoodPineOiled", metal: "PaintMetalBlack" },
			{ wood: "WoodPineOiled", metal: "MetalGalvanizedSteel" },
			{ wood: "WoodTeakUntreated", metal: "PaintMetalGreen" },
			{ wood: "WoodOakOiled", metal: "PaintMetalGreen" },
			{ wood: "LacquerWhite", metal: "PaintMetalGreen" },
			{ wood: "PaintWoodGreen", metal: "PaintMetalGreen" },
			{ wood: "PaintWoodRed", metal: "PaintMetalGreen" },
		],
	},
	"Table-9A-100": {
		wood: [
			"WoodTeakUntreated",
			"WoodOakOiled",
			"WoodPineOiled",
			"LacquerWhite",
			"PaintWoodGreen",
			"PaintWoodRed",
		],
		metal: ["MetalGalvanizedSteel", "PaintMetalBlack", "PaintMetalGreen"],
		excludedCombos: [
			{ wood: "WoodPineOiled", metal: "PaintMetalBlack" },
			{ wood: "WoodPineOiled", metal: "MetalGalvanizedSteel" },
			{ wood: "WoodTeakUntreated", metal: "PaintMetalGreen" },
			{ wood: "WoodOakOiled", metal: "PaintMetalGreen" },
			{ wood: "LacquerWhite", metal: "PaintMetalGreen" },
			{ wood: "PaintWoodGreen", metal: "PaintMetalGreen" },
			{ wood: "PaintWoodRed", metal: "PaintMetalGreen" },
		],
	},
	"Table-9A-120": {
		wood: [
			"WoodTeakUntreated",
			"WoodOakOiled",
			"WoodPineOiled",
			"LacquerWhite",
			"PaintWoodGreen",
			"PaintWoodRed",
		],
		metal: ["MetalGalvanizedSteel", "PaintMetalBlack", "PaintMetalGreen"],
		excludedCombos: [
			{ wood: "WoodPineOiled", metal: "PaintMetalBlack" },
			{ wood: "WoodPineOiled", metal: "MetalGalvanizedSteel" },
			{ wood: "WoodTeakUntreated", metal: "PaintMetalGreen" },
			{ wood: "WoodOakOiled", metal: "PaintMetalGreen" },
			{ wood: "LacquerWhite", metal: "PaintMetalGreen" },
			{ wood: "PaintWoodGreen", metal: "PaintMetalGreen" },
			{ wood: "PaintWoodRed", metal: "PaintMetalGreen" },
		],
	},
	"Table-B25A-120": {
		wood: [
			"WoodTeakUntreated",
			"WoodOakOiled",
			"WoodPineOiled",
			"LacquerWhite",
			"PaintWoodGreen",
			"PaintWoodRed",
		],
		metal: ["MetalGalvanizedSteel", "PaintMetalBlack", "PaintMetalGreen"],
		excludedCombos: [
			{ wood: "WoodPineOiled", metal: "PaintMetalBlack" },
			{ wood: "WoodPineOiled", metal: "MetalGalvanizedSteel" },
			{ wood: "WoodTeakUntreated", metal: "PaintMetalGreen" },
			{ wood: "WoodOakOiled", metal: "PaintMetalGreen" },
			{ wood: "LacquerWhite", metal: "PaintMetalGreen" },
			{ wood: "PaintWoodGreen", metal: "PaintMetalGreen" },
			{ wood: "PaintWoodRed", metal: "PaintMetalGreen" },
		],
	},
	"Table-HighTech-60": {
		wood: ["LaminateWhite", "LaminateGraphite"],
		metal: ["MetalGalvanizedSteel", "PaintMetalBlack"],
	},
	"Table-HighTech-110": {
		wood: ["LaminateWhite", "LaminateGraphite"],
		metal: ["MetalGalvanizedSteel", "PaintMetalBlack"],
	},
	"Table-Libelle-140": {
		wood: [],
		metal: ["PaintMetalGreen", "PaintMetalGrey", "PaintMetalGraphite"],
	},
	"Table-Libelle-70": {
		wood: [],
		metal: ["PaintMetalGreen", "PaintMetalGrey", "PaintMetalGraphite"],
	},
	"Table-Bovik-150": {
		wood: ["WoodTeakUntreated"],
		metal: ["MetalGalvanizedSteel", "PaintMetalBlack"],
	},
};
